import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const ButtonWrapper = styled.div`
  padding: ${rem(16)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
      padding: ${rem(14)} ${rem(20)};
    `}
`;

export const Wrapper = styled.div`
  .intersection-observer-wrap:last-child {
    .text-area {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;
